/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import React from 'react';
import SearchComponent from './SearchComponent';
import { searchOrganizationByName } from '../../actions/common';
import { Suggestion } from '@g17eco/types/search';
import { Avatar } from '@g17eco/atoms/avatar';

const renderSuggestion = (suggestion: Suggestion) => {
  return (
    <div className='suggestion-item'>
      <Avatar width='30px'>
        {suggestion.profile ? <img alt='avatar' src={suggestion.profile} /> : <></>}
      </Avatar>
      <span>
        <div><strong>{suggestion.name}</strong></div>
      </span>
    </div>
  );
}

interface OrganizationSearchProps {
  name?: string;
  inputClassName?: string;
  required?: boolean;
  handleValueChange: (searchStr: string, currentSuggestion?: Suggestion) => void;
}

export function OrganizationSearch(props: OrganizationSearchProps) {
  return (
    <SearchComponent
      {...props}
      placeholder={'Search company'}
      searchAction={searchOrganizationByName}
      autoComplete={'organization'}
      renderSuggestion={renderSuggestion}
      />
  );
}
